import { gsap } from "./gsap";

export function createTextReveal(lines: gsap.TweenTarget, trigger: gsap.DOMTarget): void {
  gsap.fromTo(
    lines,
    { yPercent: 115 },
    {
      yPercent: 0,
      duration: 1.05,
      stagger: 0.09,
      scrollTrigger: { trigger, start: "top 82%" },
    }
  );
}
